import React, { useEffect, useState } from 'react';
import {
    Typography, Grid, Card, Button, Menu, MenuItem, Box, IconButton, Dialog, DialogTitle, CardActionArea, DialogContent, DialogActions, Chip, Snackbar, Alert, CircularProgress, Tooltip
} from '@mui/material';
import PanToolIcon from '@mui/icons-material/PanTool';
import moment from "moment";
import { axiosFetch } from "../../../utils/AxiosFetch";
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { SnackbarActions } from '../../../redux/actions/snackbar.actions';
import { styled } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
import PropTypes from 'prop-types';
import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { training_details, team_training, training_list, my_training } from '../../../redux/actions/training.action';
import './Training.css';
import Training from '../../../assets/demotraining.jpeg'
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import ReplayIcon from '@mui/icons-material/Replay';
import DescriptionIcon from '@mui/icons-material/Description';
import LinkIcon from '@mui/icons-material/Link';
import ListAltIcon from '@mui/icons-material/ListAlt';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import LanguageIcon from '@mui/icons-material/Language';
import ClassIcon from '@mui/icons-material/Class';
import { ConfirmationModal } from '../../../shared/index';
import PeopleIcon from '@mui/icons-material/People';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

const BootstrapDialogTitle = (props) => {
    const { children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
};

BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
};

function TrainingList(props) {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [open, setOpen] = React.useState(false);
    const [comment, setComment] = useState("");
    const [userId, setUserId] = useState("");
    const [trainingId, setTrainingId] = useState("");
    const [isApprove, setIsApprove] = useState(true);
    const [userName, setUserName] = useState("");
    const [details, setDetails] = useState({})
    const dispatch = useDispatch();
    const navigate = useNavigate();
    var isUserLogged = localStorage.getItem('argus_user') !== null ? JSON.parse(localStorage.getItem('argus_user')) : "";
    const menuOpen = Boolean(anchorEl);
    const [isChangeStatus, setIsChangeStatus] = useState(false);   
    const [statusval, setStatusval] = useState("")
    const [confirmation, setConfirmation] = useState(false)
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [rejectComment, setRejectComment] = useState("");
    const [loading, setLoading] = useState(false);
    const [loadingunroll, setLoadingUnroll] = useState(false);
    const [confirmModal, setConfirmModal] = useState(false);
    const [unrollId, setUnrollId] = useState(0);
    const [approveLoading, setApproveLoading] = useState(false);
    const [rejectLoading, setRejectLoading] = useState(false);

    let TrainingDetail = useSelector(state => state.fetchTrainingDetails_Reducer.trainingDetails)

    useEffect(() => {
        if (TrainingDetail !== undefined) {
            setDetails(TrainingDetail)
        }
    }, [TrainingDetail])
    const formatDate = (date) => {
        return moment(date).format('MMM-DD-YYYY');
    }
    const handleClose = () => {
        setOpen(false);
        setIsApprove(true);
        setIsChangeStatus(false);
        setConfirmation(false)
    };
    const handleCloseSnack = () => {
        setSnackbarOpen(false)
    }
    const handleRequest = (id,attendees,interested,maxslot) => {
        console.log(id,attendees,interested,maxslot)
        var interest;
        var attendingUsers;
        if(interested === null){
            interest = 0;
        }
        else{
            interest = interested;
        }
        if(attendees === null){
            attendingUsers = 0;
        }
        else{
            attendingUsers = attendees
        }
        if(parseInt(attendingUsers) + parseInt(interest) < maxslot || maxslot === 0 || maxslot === null){
            setLoading(true)
            if (id !== undefined && loading === false) {
                axiosFetch({
                    url: `/Training/request/${id}`,
                    method: "post",
                })
                    .then((res) => {
                        if (res.status === 200) {
                            var req = {
                                "page": 1,
                                "resultsPerPage": 6,
                                "title": "",
                                "year": "",
                            }
                            if (isUserLogged.usertype === "Admin" || isUserLogged === "SuperAdmin") {
                                setLoading(false)
                                dispatch(SnackbarActions(true, "success", "Your interest was registered successfully"))
                                dispatch(training_list(req))
                            }
                            else {
                                setLoading(false)
                                dispatch(SnackbarActions(true, "success", "Your interest was send to your manager"))
                                dispatch(training_list(req))
                            }
                        }
                        if (res.status === 400) {
                            dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));
                        }
                        if (res.status === 401) {
                            navigate("/");
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            }
        }
        else{
            dispatch(SnackbarActions(true, "info", "Oops, Slots are filled"))
        }
        
    }

    const handleApprove = (trainId, uId, fname, lname) => {
        var req = {
            "employeeId": uId,
            "isApproved": true,
            "trainingId": trainId,
            "reportingManagerComment": ""
        }
        setApproveLoading(true)
        setTrainingId(trainId)
        setUserId(uId)
        setIsApprove(true)
        setComment("")
        handleConfirmation(req)
        setUserName(fname + '' + lname)
    }
    const handleReject = (trainId, uId, fname, lname) => {
        setTrainingId(trainId)
        setUserId(uId)
        // setOpen(true)
        setIsApprove(false)
        setUserName(fname + '' + lname)
    }
    const handlePopup = (id) => {
        setOpen(true)
        setTrainingId(id)
        dispatch(training_details(id))
    }
    const handleData = () => {
        var req = {
            "employeeId": userId,
            "isApproved": isApprove,
            "trainingId": trainingId,
            "reportingManagerComment": comment
        }
        setRejectLoading(true)
        handleConfirmation(req)
    }
    const handleConfirmation = (req) => {

        axiosFetch({
            url: `/Training/approval`,
            method: "post",
            requestConfig: req
        })
            .then((res) => {
                if (res.status === 200) {
                    if (isApprove) {
                        dispatch(SnackbarActions(true, "success", "Approved successfully"))
                        setApproveLoading(false)
                        handleClose()
                        dispatch(team_training())
                    }
                    else {
                        dispatch(SnackbarActions(true, "success", `This Training has been rejected for ${userName} `))
                        setRejectLoading(false)
                        handleClose()
                        dispatch(team_training())
                    }
                }
                if (res.status === 400) {
                    dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));
                }
                if (res.status === 401) {
                    navigate("/");
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }
    ValidatorForm.addValidationRule('isEmpty', (value) => {
        if (value.trim().length === 0) {
            return false;
        }
        return true;
    });
    const handleClick = (event, id) => {
        setTrainingId(id)
        setAnchorEl(event.currentTarget);
    };
    const handleMenuClose = () => {
        setAnchorEl(null);
    }
    const handleEditTraining = (name) => {
        props.handleEdit()
        props.handleEditModal()
        props.setTrainingId(trainingId, name)
        setAnchorEl(null);
    }
    const handleCopyTraining = (name) => {
        props.handleEditModal()
        props.setTrainingId(trainingId, name)
        setAnchorEl(null);
    }
    const handleStatus = (status, id, attendeesCount) => {
        setAnchorEl(null);
        if (attendeesCount !== 0) {
            setOpen(true)
            setIsChangeStatus(true)
            setTrainingId(id)
            setStatusval(status)
        }
        else {
            setSnackbarOpen(true)
            setRejectComment("There are no attendees to schedule this training")
        }


    }
    const handleChange = () => {
        var change;
        if (statusval === "Open") {
            change = true
        }
        else {
            change = false
        }
        var req = {
            "topicId": trainingId,
            "isChange": change
        }
        axiosFetch({
            url: `/Training/status`,
            method: "post",
            requestConfig: req
        })
            .then((res) => {
                if (res.status === 200) {
                    var req = {
                        "page": 1,
                        "resultsPerPage": 6,
                        "title": "",
                        "year": "",
                    }
                    dispatch(SnackbarActions(true, "success", `This Training has been changed `))
                    handleClose()
                    dispatch(training_list(req))
                }
                if (res.status === 400) {
                    dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));
                }
                if (res.status === 401) {
                    navigate("/");
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }
    const handleDelete = (id,name) => {
        setAnchorEl(null);
        // setConfirmation(true)
        // setOpen(true)
        setTrainingId(id)
        props.handleConfirmation(id,"delete",name)
    }
    const deleteTraining = () => {
        axiosFetch({
            url: `/Training/${trainingId}`,
            method: "delete",
        })
            .then((res) => {
                if (res.status === 200) {
                    var req = {
                        "page": 1,
                        "resultsPerPage": 6,
                        "title": "",
                        "year": "",
                    }
                    dispatch(SnackbarActions(true, "success", `Deleted Successfully `))
                    handleClose()
                    dispatch(training_list(req))
                }
                if (res.status === 400) {
                    dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));
                }
                if (res.status === 401) {
                    navigate("/");
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }

    const handleRejectComment = (val) => {
        // if(props.from !== "mytraining"){
        props.handleCommentModal(val)

        // }
        // setcommentModal(true)
        setRejectComment(val)
    }

    const handleDescription = (data) => {
        if (data === null || data === "" || data === undefined) {
            return "—"
        }
        else {
            return data.slice(0, 250);
        }
    }
    const handleModal = (id, type, count, status, title, startDate) => {
        if (count > 0) {
            props.handleAttendees(id, type, status, title, startDate)
        }
        else {
            setRejectComment("No Employees Found")
            setSnackbarOpen(true)
        }
    }
    const handleUnroll = () => {
        if (unrollId !== 0) {
            setLoadingUnroll(true)
            var req = {
                "id": unrollId
            }
            axiosFetch({
                url: `/Training/unroll`,
                method: "post",
                requestConfig: req
            })
                .then((res) => {
                    if (res.status === 200) {
                        var req = {
                            "page": 1,
                            "resultsPerPage": 6,
                        }
                        setLoadingUnroll(false)
                        dispatch(SnackbarActions(true, "success", `Training has been unrolled Successfully `))
                        dispatch(my_training(req))

                    }
                    if (res.status === 400) {
                        dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));
                    }
                    if (res.status === 401) {
                        navigate("/");
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    }

    const handleConfirmModal = (id) => {
        if (confirmModal) {
            setUnrollId(0);
            setConfirmModal(false);
        }
        else {
            setUnrollId(id)
            setConfirmModal(true)
        }
    }
    const card = (
        props.from === "teamtraining" ?
            <React.Fragment>
                <CardActionArea onClick={() => handlePopup(props.id)} sx={{ padding: 1 }}>
                    <Grid container spacing={2}>
                        <Grid item xs={4} sx={{ height: 10 }}>
                            <Typography className='stensil-para' sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
                                {props.firstName + ' ' + props.lastName}
                            </Typography>
                        </Grid>
                        <Grid item xs={4} className='stensil-ignore' sx={{ textAlign: 'left' }}>
                            {props.title}
                        </Grid>
                        <Grid item xs={4} className='stensil-ignore' sx={{ textAlign: 'center' }}>
                            {formatDate(props.startDate)} to {formatDate(props.endDate)}
                        </Grid>
                    </Grid>
                </CardActionArea>
            </React.Fragment> :
            <React.Fragment>
                {/* <CardContent> */}
                <Grid container spacing={1} sx={{ display: "flex", alignItems: "center", borderRadius:"10px" }}>
                    <Grid item xs={2} className="stensil training-imgsec">
                        <img src={Training} className='training-img' alt="Courses" />
                        {/* <SchoolIcon /> */}
                    </Grid>
                    <Grid item xs={10}>
                        <div className='training-box'>
                            <Tooltip className='training-tooltip' placement='top-start' title={props.title}><h1 className='training-title stensil' onClick={() => handlePopup(props.id)}>{props.title}</h1></Tooltip>
                            <div className='training-flex'>
                                <p className='training-date stensil' style={{ fontWeight: "bold", color: "#585858" }}>
                                    {props.startDate !== null && props.endDate !== null?<><small><CalendarTodayIcon />{formatDate(props.startDate)} </small> to <small>{formatDate(props.endDate)}</small></>:""}
                                    {props.from !== "mytraining" && props.maxSlot !== null?<small style={{paddingLeft:20}}><PeopleIcon/>Max Slots: {props.maxSlot === 0?"No limit":props.maxSlot}</small>:""}
                                </p>
                                <p className='training-date stensil-ignore' style={{ fontWeight: "bold", color: "#585858" }}><small><AccessTimeIcon />{props.durationHours} Hours</small></p>
                                {/* <p className='training-date'><small><CalendarTodayIcon />3 Weeks</small></p> */}
                                {props.from === "mytraining" ? "" :
                                    <Typography className='stensil'>
                                        {props.from === "trainingHome" ?
                                            <><span style={{ color: "#113776", fontWeight: "bold", marginRight: "10px", cursor: "pointer" }} onClick={() => handleModal(props.id, "attendees", props.attendees, props.statusName, props.title, props.startDate)}>Attendees: {props.attendees !== null ? props.attendees : 0}</span>
                                                <span style={{ color: "green", fontWeight: "bold", cursor: "pointer" }} onClick={() => handleModal(props.id, "request", props.interested !== null ? props.interested : 0,props.statusName, props.title, props.startDate)}>Requested: {props.interested !== null ? props.interested : 0}</span>
                                            </> :
                                            <>
                                                <span style={{ color: "#113776", fontWeight: "bold", marginRight: "10px" }}>Attendees: {props.attendees !== null ? props.attendees : 0}</span>
                                                <span style={{ color: "green", fontWeight: "bold" }}>Requested: {props.interested !== null ? props.interested : 0}</span>

                                            </>}
                                    </Typography>
                                }
                            </div>
                            <div className='stensil desc-training'

                            // dangerouslySetInnerHTML={{__html: data}}
                            ><p>{handleDescription(props.description)}</p></div>
                            <div className='training-flex'>
                                {/* {props.from === "mytraining" ? "":
                            <> */}
                                <div className=''>
                                    {props.employeeTrainingLevel?<span className='level-text stensil level'>{props.employeeTrainingLevel} </span>:""}
                                    {props.trainingTypeName === "Online" ?
                                        <span className='level-text stensil'><LanguageIcon /> {props.trainingTypeName} </span> :
                                        <span className='level-text stensil'><ClassIcon /> {props.trainingTypeName} </span>
                                    }
                                    <span className='level-text stensil level'>{props.trainingLevel} </span>
                                </div>
                                {/* </>} */}
                                {/* {props.from === "mytraining" ?
                         <Chip size="small" label={((props.statusName === "Open" || props.statusName === "Scheduled") && props.empStatusName === "Interested")? "Waiting for confirmation":(props.statusName === "Scheduled" && props.empStatusName === "Approved")? "Yet to start":props.statusName === "On Going"?"Ongoing":(props.statusName === "Open" && props.empStatusName === "Approved")?"Coming Soon":props.empStatusName} color={props.statusName === "Open" ? "success" : props.statusName === "Scheduled" ? "primary" : props.statusName === "On Going" ? "secondary" : "error"} /> 
                        :""}                         */}

                                <p className='statuslabel stensil '>
                                    {props.statusName === "Open" ?
                                        <span className='level-text stensil open' style={{ backgroundColor: "#a7bcb3", color: "black" }}>{props.statusName}</span> :
                                        props.statusName === "Scheduled" ?
                                            <span className='level-text stensil scheduled' style={{ backgroundColor: "#94becd", color: "black" }}>{props.statusName}</span> :
                                            props.statusName === "On Going" ?
                                                <span className='level-text stensil' style={{ backgroundColor: "#ebeb49", color: "black" }}>{props.statusName}</span> :
                                                props.statusName === "Completed" ?
                                                    <span className='level-text stensil' style={{ backgroundColor: "#36cd4b", color: "black" }}>{props.statusName}</span> :

                                                    ""}
                                    {/* // <Chip className='status-chip' sx={{color:"white",backgroundColor:"#36cd4b",fontWeight:"bold",borderColor:"#36cd4b"}} label={props.statusName} />
                                    // <FiberManualRecordIcon fontSize='small' className='training-status' color={props.statusName === "Open" ? "success" : props.statusName === "Scheduled" ? "primary" : props.statusName === "On Going" ? "secondary" : "error"} /> {props.statusName} */}
                                </p>
                                {/* <Grid xs={2}> */}
                                    {props.from === "mytraining" && props.empStatusName !== "Completed" && props.empStatusName !== "Rejected"?
                                        <Button className='theme-btn' sx={{ float: "none", margin: "10px 0" }} variant="outlined"
                                            // onClick={() => handleUnroll(props.id)}
                                            onClick={() => handleConfirmModal(props.id)}
                                        >
                                            {loadingunroll ? <CircularProgress size="2rem" />
                                                : "Unroll"
                                            }

                                        </Button>
                                        : ""}
                                {/* </Grid> */}
                                {props.statusName === "Completed" || props.statusName === "On Going" ?
                                    <div className='status-chip'>
                                        {props.statusName === "Completed" ?
                                            <Chip color="error" label="Training Completed" variant="outlined" /> :
                                            <Chip color="secondary" label="Training In-progress" variant="outlined" />
                                        }
                                    </div> :
                                    <div className='stensil status-chip'>

                                        {props.empStatusName === "Rejected" ? <Tooltip title='click to view manager comment'><Chip sx={{marginRight: "10px !important"}} color="error" label="Rejected" variant="outlined" onClick={() => handleRejectComment(props.comments)} /></Tooltip> : <></>}
                                        {props.empStatusName === "Approved" || props.empStatusName === "Interested" || props.statusId === 2?
                                            <Chip variant="outlined" color={props.empStatusName === "Approved" ? "success" : "primary"} label={props.empStatusName === "Approved" ? "Already Enrolled" : props.statusId === 2 ?"Yet to start":"Waiting for confirmation"} /> :
                                            props.from === "mytraining"  ? "" :
                                                <Button className='theme-btn' sx={{ float: "none", margin: "5px 0" }} variant="outlined" endIcon={<PanToolIcon />} onClick={() => handleRequest(props.id,props.attendees,props.interested,props.maxSlot)}>
                                                    {loading ? <CircularProgress size="2rem" />
                                                        : "Interested"
                                                    }

                                                </Button>
                                        }

                                        {/* } */}
                                    </div>
                                }
                            </div>
                            {/* <p className='training-date stensil'><small>{formatDate(props.startDate)}</small> <small> to </small><small>{formatDate(props.endDate)}</small> </p> */}
                            {(isUserLogged.usertype === "Admin" && props.from !== "mytraining") || (isUserLogged.usertype === "TrainingManager" && props.from === "trainingHome") ?
                                <div className='status stensil-ignore'>
                                    <IconButton
                                        aria-controls={menuOpen ? 'demo-positioned-menu' : undefined}
                                        aria-haspopup="true"
                                        aria-expanded={menuOpen ? 'true' : undefined}
                                        onClick={(e) => handleClick(e, props.id, props.statusName)}
                                    >
                                        <MoreVertIcon />
                                    </IconButton>
                                    <Menu
                                        aria-labelledby="demo-positioned-button"
                                        anchorEl={anchorEl}
                                        className="common-menu-list"
                                        open={menuOpen}
                                        onClose={handleMenuClose}
                                        anchorOrigin={{
                                            vertical: 'bottom',
                                            horizontal: 'left',
                                        }}
                                        transformOrigin={{
                                            vertical: 'bottom',
                                            horizontal: 'left',
                                        }}
                                    >
                                        {props.statusName === "Completed" ?
                                            <MenuItem className='common-menu-list-li' divider onClick={() => handleCopyTraining(props.statusName)}><ReplayIcon /> Re-create</MenuItem> :
                                            <MenuItem className='common-menu-list-li' divider onClick={() => handleEditTraining(props.statusName)}><EditIcon /> Edit</MenuItem>}
                                        {props.statusName === "Open" || props.statusName === "Scheduled" ?
                                            <>
                                                <MenuItem className='common-menu-list-li' divider onClick={() => handleStatus(props.statusName, props.id, props.attendees)}><CalendarTodayIcon /> Change {props.statusName === "Open" ? 'to Scheduled' : 'to Open'}</MenuItem>
                                                <MenuItem className='common-menu-list-li' onClick={() => handleDelete(props.id,props.title)}><DeleteIcon /> Delete</MenuItem>
                                            </> : <></>}

                                    </Menu>
                                </div>
                                : <></>
                            }
                        </div>
                    </Grid>

                </Grid>
                {/* </CardContent> */}
            </React.Fragment>
    );
    return (
        <div>
            <Card sx={{ borderRadius: "10px", marginLeft: "0 !important", marginRight: " 0 !important", marginTop: "0 !important", margin: 2, padding: 1, boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;" }} variant="outlined">{card}</Card>
            <BootstrapDialog
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={open}
                fullWidth="sm"
                maxWidth="sm"
            >
                {confirmation !== true && isChangeStatus === false ? <BootstrapDialogTitle className="modal-heading" id="customized-dialog-title" onClose={handleClose}>
                    Training Details
                </BootstrapDialogTitle> : ""}
                <ValidatorForm onSubmit={() => handleData()}>

                    {isChangeStatus === true ?
                        <DialogContent dividers>
                            <Box>
                                <Grid container className="grid-margins">
                                    <Grid item xs={12}>
                                        <p className='modal-heading' style={{ margin: "0", paddingBottom: "15px" }}>Are you sure want to {statusval === "Open" ? "schedule" : "open"} this training?</p>
                                    </Grid>
                                    <Grid item xs={12} sx={{ borderTop: "1px solid #eee", paddingTop: "15px" }}>
                                        <Button variant="contained" className='theme-btn' sx={{ marginLeft: "10px" }} onClick={() => handleChange()}>Yes</Button>
                                        <Button variant="contained" className='theme-btn cancel-btn' onClick={() => handleClose()}>No</Button>
                                    </Grid>
                                </Grid>
                            </Box>
                        </DialogContent>
                        :
                        <DialogContent dividers>
                            {details !== undefined && confirmation === false ?
                                <div className='training-list-user'>
                                    <div className='training-details'>
                                        <Typography className='training-title'>
                                            {details.title}
                                        </Typography>
                                        <div className='details-flex'>
                                            <CalendarTodayIcon className='common-icon' fontSize='small' color='primary' />
                                            <Typography>
                                                {formatDate(details.startDate)} to {formatDate(details.endDate)}({details.durationHours} hrs)
                                            </Typography>
                                        </div>
                                        <div className='details-flex'>
                                            <DescriptionIcon fontSize='small' className='common-icon' color='primary' />
                                            <Typography>
                                                {details.description !== "" ? details.description : "Training description not available"}
                                            </Typography>
                                        </div>
                                        <div className='details-flex'>
                                            <ListAltIcon fontSize='small' className='common-icon' color='primary' />
                                            <Typography>
                                                {details.skillSet !== "" ? details.skillSet : "Skillsets not available"}
                                            </Typography>
                                        </div>
                                        <div className='details-flex'>
                                            <Typography>
                                                {details.referenceUrl !== "" ?
                                                    <><LinkIcon fontSize='small' className='common-icon' color='primary' />
                                                        <a rel="noopener noreferrer" href={details.referenceUrl} target="_blank">{details.referenceUrl}</a></>
                                                    : ""}
                                            </Typography>
                                        </div>
                                    </div>
                                    {props.work !== "view" ?
                                        <div className='btn-groups'>
                                            {approveLoading?
                                            <CircularProgress size="2rem" sx={{float:"right"}}/>:
                                            isApprove !== false?<Button color="success" className='theme-btn stensil' sx={{ marginRight: "10px" }} size="small" variant="contained" onClick={() => handleApprove(props.id, props.userId, props.firstName, props.lastName)}>
                                                Approve
                                            </Button>:""}
                                            {isApprove === false ? "" : <Button color="error" className='theme-btn danger-btn stensil' size="small" variant="contained" onClick={() => handleReject(props.id, props.userId, props.firstName, props.lastName)}>
                                                Reject
                                            </Button>}
                                        </div> : ""}
                                </div>
                                : <>
                                    <Box>
                                        <Grid container className="grid-margins">
                                            <Grid item xs={12} >
                                                <p className='modal-heading' style={{ margin: "0", paddingBottom: "15px" }}>Are you sure want to delete this training?</p>
                                            </Grid>
                                            <Grid item xs={12} sx={{ borderTop: "1px solid #eee", paddingTop: "15px" }}>
                                                <Button variant="contained" className='theme-btn' sx={{ marginLeft: "10px" }} onClick={() => deleteTraining()}>Yes</Button>
                                                <Button variant="contained" className='theme-btn cancel-btn' onClick={() => handleClose()}>No</Button>
                                            </Grid>
                                        </Grid>
                                    </Box>
                                </>
                            }
                            <br />
                            {isApprove === false ? <TextValidator
                                id="input-with-icon-textfield"
                                variant="outlined"
                                value={comment}
                                onChange={(e) => setComment(e.target.value)}
                                fullWidth
                                label="Rejection Comment"
                                type="text"
                                rows={3}
                                multiline
                                validators={["required", "isEmpty"]}
                                errorMessages={["Please fill out this field", "Comment should not be empty"]}
                            /> : ""}

                        </DialogContent>}
                    {isApprove === false ?
                        <DialogActions>
                            {rejectLoading?
                            <CircularProgress size="2rem"/>:
                            <Button color="error" className="theme-btn danger-btn" variant="contained" type="submit">Reject</Button>}
                            <Button className="theme-btn cancel-btn"  variant="contained" onClick={() => setIsApprove(true)} disabled={rejectLoading}>Cancel</Button>
                        </DialogActions> : ""}
                </ValidatorForm>

            </BootstrapDialog>
            <Snackbar
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                open={snackbarOpen}
                onClose={handleCloseSnack}
            >
                <Alert severity="warning" variant="filled" onClose={handleCloseSnack} elevation={6}>
                    {rejectComment}

                </Alert>
            </Snackbar>
            <ConfirmationModal open={confirmModal} handleClose={handleConfirmModal} message={"Are you sure you want to unroll this training?"} handleYes={handleUnroll} />
        </div >
    )
}
export default TrainingList;